import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Header';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'S&P 500<sup>&reg</sup> FIA Return Calculator',
  },
});